var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _radialGradient, _path9, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.11,
    cy: 19.16,
    r: 8.56,
    fill: "#e2a610"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.19 24.18c-.48-.62-.92-1.28-1.31-1.97c-.04-.07-.08-.14-.09-.21c-.02-.12.02-.24.05-.36c.24-.82.32-1.68.25-2.52c-.06-.65-.21-1.29-.21-1.94c0-.43.23-1.91.79-1.54c.48.32.83 1.41 1.02 1.93c.49 1.36.61 2.86.34 4.28c-.15.81-.43 1.6-.84 2.33z",
    fill: "#9e740b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.03 12.59c.49.45.67 1.29.23 1.78c-.27.3-.79.52-1.44.47c-1.31-.09-2.29.23-3 .51c-1.63.64-2.47.27-2.54-.39s.12-1.87 2.63-2.65c2.51-.77 3.78-.03 4.12.28z",
    fill: "#ffca28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.45 33.8s.91-3.49 1.53-5.55c.84-2.81 1.49-8 5.61-7.37c1.8.28 3.35 2.08 3.09 3.9l-2.57 9.01h-7.66z",
    fill: "#ffca28"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.89,
    cy: 19.16,
    r: 8.56,
    fill: "#ffca28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.99 13.32c.44.89 0 1.81-2.02 3.03c-2.09 1.26-2.38 2.41-3.24 3.31c-.7.73-2.07.46-2.23-.52c-.38-2.3.73-4.11 1.78-5.2c1.6-1.67 4.77-2.5 5.71-.62z",
    fill: "#ffe36c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.77 24.24c.3-.41.73-1.09.9-1.53c.05-.12-.34.03-.69.36c-.76.73-2.25 2.23-5.1 3.09c-3.71 1.12-6.32-.24-6.7-.12c-.39.13.98.81 1.18.9c.71.32 1.47.55 2.24.67l.51 1.72h7.67l-1.15-3.82c.4-.36.79-.79 1.14-1.27z",
    fill: "#9e740b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.46 29.34H26.54c-10.61 0-13.57 7.41-13.57 13.79v25.89h102.08V43.13c-.01-6.38-2.98-13.79-13.59-13.79z",
    fill: "#ffca28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 55.51s.75 1.37 4.1.38c3.35-.99 4.9-6.92 4.9-6.92l-.42 20.05h-8.58V55.51z",
    fill: "#e2a610"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.04 54.56s-.89 1.39-4.18.48c-3.3-.92-4.61-7.54-4.61-7.54l.26 21.53h8.53V54.56z",
    fill: "#e2a610"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19789",
    cx: 68.783,
    cy: 54.677,
    r: 127.376,
    gradientTransform: "matrix(1 .00336 -.00186 .5531 .102 24.205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#ff689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6336b"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.28 63.93c-4.48-7.53-5.55-11.09-6.19-18.01c-.42-4.54-1.72-8.05-6.17-8.05H28.08c-4.45 0-5.75 3.52-6.17 8.05c-.64 6.91-1.71 10.48-6.19 18.01c-6.9 11.6-12.62 21.95-11.6 29.21c1.95 13.9 14.39 29.79 24.29 29.79h71.18c9.91 0 22.34-15.89 24.29-29.79c1.02-7.26-4.7-17.61-11.6-29.21z",
    fill: "url(#IconifyId17ecdb2904d178eab19789)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d6336b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.93 37.99S38.25 54.03 44.07 57.95c6 4.04 12.86-19.96 12.86-19.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2 67.99c8.14 0-.42-30.19-.42-30.19s-7.72 30.19.42 30.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.45 37.8s5.93 24.55 12.28 20.32S71.45 37.8 71.45 37.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurse);
export default __webpack_public_path__ + "static/media/purse.5838f31198a66be0cd4bf2f43000408a.svg";
export { ForwardRef as ReactComponent };